var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderVideo)?_c('video',{ref:"videoPlayer",staticClass:"z-0 w-full h-full",attrs:{"controls":"","autoplay":""}},[_c('source',{attrs:{"src":_vm.fileUrl,"type":_vm.item.mimeType}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }